import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteExtractionRight } from "@services/extractionRight";
import { isFunction } from "lodash";

export const useDeleteExtractionRight = (options: Record<string, any> = {}) => {
  const queryClient = useQueryClient();

  return useMutation(deleteExtractionRight, {
    onSuccess: (res: any) => {
      queryClient.invalidateQueries({ queryKey: ["extractionRights"] });

      if (isFunction(options.onSuccess)) {
        options.onSuccess(res);
      }
    },
    ...options,
  });
};
